<app-main-wrapper>
  <div class="options-container">
    <div class="page-header">
      <h1 class="page-title">Settings</h1>
    </div>

    <div class="content" *ngIf="!isLoading">
      <form [formGroup]="optionsForm">
        
        <!-- Ignored Domains Section -->
        <div class="section">
          <h2>Ignored domains</h2>
          <p class="description">
            Add domains to classify meetings as internal. The bot won't join meetings with attendees from these domains.
          </p>
          
          <div class="domains-checklist">
            <!-- Existing Ignored Domains -->
            <div class="domain-checklist-item" *ngFor="let control of ignoredDomainsArray.controls; let i = index" formArrayName="ignoredDomains">
              <label class="domain-checkbox-container">
                <input
                  type="text"
                  [formControlName]="i"
                  class="domain-input-edit"
                  placeholder="example.com"
                  (input)="onDomainChange()"
                />
                <button
                  type="button"
                  class="btn-remove-inline"
                  (click)="removeIgnoredDomainField(i)"
                >
                  ✕
                </button>
              </label>
            </div>

            <!-- Add Domain Input -->
            <div class="add-domain-section">
              <input
                type="text"
                [(ngModel)]="newIgnoredDomain"
                [ngModelOptions]="{standalone: true}"
                placeholder="Enter domain (e.g., company.com)"
                class="domain-input-add"
                (keyup.enter)="addNewIgnoredDomain()"
              />
              <button 
                type="button" 
                class="btn-add-inline" 
                (click)="addNewIgnoredDomain()"
                [disabled]="!newIgnoredDomain || !newIgnoredDomain.trim()"
              >
                <i class="fa-solid fa-plus"></i> Add
              </button>
            </div>
          </div>
        </div>

        <!-- Battle Card Domains Section -->
        <div class="section">
          <h2>Battlecard priority URLs</h2>
          <p class="description">
            Enter URLs to prioritize for web answers in battlecards.
          </p>

          <!-- Domains Checklist -->
          <div class="domains-checklist">
            <!-- Default Domain Item -->
            <div class="domain-checklist-item default-domain" *ngIf="userDefaultDomain" [class.disabled]="isFreeEmailDomain">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  [checked]="!bcIgnoreDefaultDomain.value"
                  (change)="toggleDefaultDomain()"
                  [disabled]="isFreeEmailDomain"
                />
                <span class="domain-text">
                  {{ userDefaultDomain }}
                  <span class="badge badge-default">Default</span>
                </span>
              </label>
            </div>

            <!-- Free Email Notice -->
            <div class="free-email-notice" *ngIf="isFreeEmailDomain">
              <i class="fa-solid fa-circle-info"></i>
              <span>Free email domains ({{ userDefaultDomain }}) are not prioritized. Add custom URLs below.</span>
            </div>

            <!-- Additional Domains List -->
            <div class="domain-checklist-item" *ngFor="let domain of bcDomainsArray.controls; let i = index" formArrayName="bcDomains" [class.disabled]="!isBcDomainEnabled(i)">
              <label class="domain-checkbox-container">
                <input
                  type="checkbox"
                  [checked]="isBcDomainEnabled(i)"
                  (change)="toggleBcDomain(i)"
                />
                <input
                  type="text"
                  [formControlName]="i"
                  class="domain-input-edit"
                  placeholder="domain.com"
                  (input)="onDomainChange()"
                  [disabled]="!isBcDomainEnabled(i)"
                />
              </label>
            </div>

            <!-- Add Domain Input -->
            <div class="add-domain-section">
              <input
                type="text"
                [(ngModel)]="newBcDomain"
                [ngModelOptions]="{standalone: true}"
                placeholder="Enter URL (e.g., https://docs.company.com)"
                class="domain-input-add"
                (keyup.enter)="addNewBcDomain()"
              />
              <button 
                type="button" 
                class="btn-add-inline" 
                (click)="addNewBcDomain()"
                [disabled]="!newBcDomain || !newBcDomain.trim()"
              >
                <i class="fa-solid fa-plus"></i> Add
              </button>
            </div>
          </div>
        </div>

        <!-- Save Button -->
        <div class="actions">
          <button
            type="button"
            class="btn-save"
            [disabled]="optionsForm.invalid || optionsForm.pristine || isSaving"
            (click)="save()"
          >
            {{ isSaving ? 'Saving...' : 'Save Changes' }}
          </button>
        </div>
      </form>
    </div>

    <!-- Loading State -->
    <div class="loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading settings...</p>
    </div>
  </div>
</app-main-wrapper>
